import { CircularProgress } from '@mui/material'
import { Container, Message } from '../../common/primitives'

const DownloadProgress = () => (
  <>
    <Message>Retrieving your files...</Message>
    <Container>
      <CircularProgress />
    </Container>
  </>
)

export default DownloadProgress
